import React from 'react';
import clsx from 'clsx';
import Typography from '@smart-tv/components/typography';
import styles from './player-product-sheet-info.module.scss';

interface DescriptionFieldProps {
  description: string;
  hasHeadline: boolean;
}

const DescriptionField = ({ description, hasHeadline }: DescriptionFieldProps) => {
  return (
    <Typography
      variant="bodySmall"
      className={clsx(styles['player-product-sheet-info__description'], {
        [styles['player-product-sheet-info__description--with-headline']]: hasHeadline,
      })}
    >
      {description}
    </Typography>
  );
};

export default DescriptionField;
